const KeenSlider = window.KeenSlider
const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.slidesContainer = this.els.slides?.element
    this.slideSelector = this.els.slide?.selector
    this.allSlides = Array.from(
      this.slidesContainer?.querySelectorAll(this.slideSelector) || [],
    )

    this.carousel = null
    this.reinitCarousel()
  }

  setupListeners () {
    super.setupListeners()
    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.reinitCarousel = this.reinitCarousel.bind(this)

    document.addEventListener('tabChanged', this.reinitCarousel)
    this.els.filter?.element?.addEventListener(
      'change',
      this.handleFilterChange,
    )
  }

  handleFilterChange (event) {
    const selectedType = event.target.value

    this.slidesContainer.innerHTML = ''
    this.allSlides
      .filter(
        (slide) =>
          selectedType === 'all' || slide.dataset.type === selectedType,
      )
      .forEach((slide) => this.slidesContainer.appendChild(slide))

    this.reinitCarousel()
  }

  reinitCarousel () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }

    this.carousel = new KeenSlider(
      this.slidesContainer,
      {
        selector: this.slideSelector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 1,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 'auto',
              spacing: 1,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
